module.exports = __webpack_public_path__ + "static/media/votingform-bg.aabf1ec3.jpg";